import { Return, ReturnProduct } from 'skladon-types';

import { ReturnsMapper } from '../ReturnsMapper';
import { asInt } from './coerceNumbers';

const coerceReturnLine = (line: ReturnProduct): ReturnProduct => ({
    ...line,
    quantity: asInt(line.quantity) ?? line.quantity,
    ...(line.received === undefined ? {} : { received: asInt(line.received) ?? line.received }),
});

const coerceReturn = (row: Return): Return => {
    if (!row.returnedOrderProducts) {
        return row;
    }
    return {
        ...row,
        returnedOrderProducts: row.returnedOrderProducts.map((line) => coerceReturnLine(line)),
    };
};

const coerceReturnRow = (row: object): object => {
    if (!('returnedOrderProducts' in row) || !Array.isArray(row.returnedOrderProducts)) {
        return row;
    }
    return {
        ...row,
        returnedOrderProducts: row.returnedOrderProducts.map((line) => coerceReturnLine(line as ReturnProduct)),
    };
};

export class ReturnsMapperV21 {
    public static fromCore(
        ...args: Parameters<typeof ReturnsMapper.fromCore>
    ): ReturnType<typeof ReturnsMapper.fromCore> {
        return coerceReturn(ReturnsMapper.fromCore(...args));
    }

    public static fromCoreGrid(
        ...args: Parameters<typeof ReturnsMapper.fromCoreGrid>
    ): ReturnType<typeof ReturnsMapper.fromCoreGrid> {
        const grid = ReturnsMapper.fromCoreGrid(...args);
        return {
            ...grid,
            data: grid.data.map((row) => coerceReturnRow(row)),
        };
    }

    public static toCore = ReturnsMapper.toCore;
    public static toCoreGrid = ReturnsMapper.toCoreGrid;
}
